export type PjTestType = 'ETS' | 'RESIDENT';
